module.exports = __webpack_public_path__ + "img/login-logo.3aff84ef.png";